import React from 'react';

/**
 * Copy and paste in the student IDE (Lab.clipboardPolicy). Enforced by the IDE
 * page itself; blocked attempts land in the student's activity log.
 */
export const CLIPBOARD_POLICIES = [
  {
    value: 'allow',
    label: 'Allowed',
    hint: 'Students copy and paste as usual.',
  },
  {
    value: 'within_ide',
    label: 'Only within the IDE',
    hint: 'Text copied inside the IDE can be pasted inside it. Nothing from outside can be pasted in, and nothing copied in the IDE can be pasted elsewhere.',
  },
  {
    value: 'block',
    label: 'Not allowed',
    hint: 'No copying or pasting at all, in the editor or the terminal. Students type their code and commands.',
  },
];

export function clipboardPolicyLabel(value) {
  return (CLIPBOARD_POLICIES.find((option) => option.value === value) || CLIPBOARD_POLICIES[0]).label;
}

export default function ClipboardPolicyField({
  value = 'allow', onChange, disabled = false, name = 'clipboard-policy', note, quietLegend = false,
}) {
  return (
    <fieldset className="choice-field" disabled={disabled}>
      <legend className={`choice-field__legend${quietLegend ? ' choice-field__legend--quiet' : ''}`}>
        Copy and paste in the IDE
      </legend>
      <div className="choice-field__options">
        {CLIPBOARD_POLICIES.map((option) => {
          const id = `${name}-${option.value}`;
          return (
            <label key={option.value} htmlFor={id} className={`choice-field__option${value === option.value ? ' is-selected' : ''}`}>
              <input
                type="radio"
                id={id}
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
                disabled={disabled}
              />
              <span className="choice-field__text">
                <span className="choice-field__label">{option.label}</span>
                <span className="choice-field__hint">{option.hint}</span>
              </span>
            </label>
          );
        })}
      </div>
      {value !== 'allow' && (
        <p className="choice-field__note">
          Every blocked attempt is recorded in the student&apos;s activity. This stops ordinary copying and pasting;
          a determined student with browser tools can still get around it.
          {note ? ` ${note}` : ''}
        </p>
      )}
    </fieldset>
  );
}
